import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  makeStyles,
} from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import AssignmentIcon from "@material-ui/icons/Assignment";

const useStyles = makeStyles({
  listItem: {
    height: 40,
    marginTop: 7,
    "&:hover": {
      borderRadius: 20,
    },
    "& svg": {
      color: "#C9C8C8",
    },
    "& .MuiIconButton-root": {
      padding: 0,
    },
  },
  wrapperItem: {
    padding: 0,
  },
  activeListItem: {
    width: 255,
    borderRadius: 20,
    backgroundImage: "linear-gradient(278deg, #0F76AF, #004B81)",
    color: "white",
    "& svg": {
      color: "white",
    },
  },
  nestedListItem: {
    height: 40,
    width: 242,
    marginTop: 7,
    marginLeft: 10,
    paddingLeft: 75,
    color: "#000",
    "&:hover": {
      borderRadius: 20,
    },
    "& svg": {
      color: "#C9C8C8",
    },
  },
  activeNestedListItem: {
    borderRadius: 20,
    backgroundImage: "linear-gradient(278deg, #0F76AF, #004B81)",
    color: "white",
    "& svg": {
      color: "white",
    },
  },
});

interface OwnProps {
  handleDrawerToggle: () => void;
}
type Props = OwnProps;

const DatosItem: React.FC<Props> = (props) => {
  const { handleDrawerToggle } = props;
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (
      !pathname.startsWith("/datos")
      // !pathname.startsWith("/datos-salud") &&
      // !pathname.startsWith("/datos-vecino") &&
      // !pathname.startsWith("/datos-defensa-civil") &&
      // !pathname.startsWith("/datos-mesa-ayuda") &&
      // !pathname.startsWith("/datos-defensa-civil")
    ) {
      setOpen(false);
    }
  }, [pathname]);

  const datosClicked = () => {
    setOpen((open) => !open);
  };

  return (
    <>
      <ListItem
        button
        className={classes.listItem}
        onClick={() => {
          datosClicked();
        }}
      >
        <ListItem className={classes.wrapperItem}>
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText primary="Datos" />
        </ListItem>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <NavLink
            to="/datos"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {({ isActive }) => (
              <ListItem
                button
                className={`${classes.nestedListItem} ${
                  isActive ? classes.activeNestedListItem : ""
                }`}
                onClick={handleDrawerToggle}
              >
                <ListItemText primary="VeDi" />
              </ListItem>
            )}
          </NavLink>
          {/* <NavLink
            to="/datos-salud"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {({ isActive }) => (
              <ListItem
                button
                className={`${classes.nestedListItem} ${
                  isActive ? classes.activeNestedListItem : ""
                }`}
                onClick={handleDrawerToggle}
              >
                <ListItemText primary="0800 Salud" />
              </ListItem>
            )}
          </NavLink>
          <NavLink
            to="/datos-vecino"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {({ isActive }) => (
              <ListItem
                button
                className={`${classes.nestedListItem} ${
                  isActive ? classes.activeNestedListItem : ""
                }`}
                onClick={handleDrawerToggle}
              >
                <ListItemText primary="0800 AT al Vecino" />
              </ListItem>
            )}
          </NavLink>
          <NavLink
            to="/datos-mesa-ayuda"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {({ isActive }) => (
              <ListItem
                button
                className={`${classes.nestedListItem} ${
                  isActive ? classes.activeNestedListItem : ""
                }`}
                onClick={handleDrawerToggle}
              >
                <ListItemText primary="Mesa de Ayuda" />
              </ListItem>
            )}
          </NavLink>
          <NavLink
            to="/datos-defensa-civil"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {({ isActive }) => (
              <ListItem
                button
                className={`${classes.nestedListItem} ${
                  isActive ? classes.activeNestedListItem : ""
                }`}
                onClick={handleDrawerToggle}
              >
                <ListItemText primary="Defensa Civil" />
              </ListItem>
            )}
          </NavLink> */}
        </List>
      </Collapse>
    </>
  );
};

export default DatosItem as React.ComponentType<Props>;
